"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LazyImage", {
  enumerable: true,
  get: function get() {
    return _LazyImage.LazyImage;
  }
});
exports.ResponsiveImage = exports.Image = void 0;

var _react = _interopRequireDefault(require("react"));

var _Image = require("./Image.shared");

var _LazyImage = require("./LazyImage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Image */
var Image = function Image(_ref) {
  var _ref$lazyLoad = _ref.lazyLoad,
      lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
      props = _objectWithoutProperties(_ref, ["lazyLoad"]);

  return _react.default.createElement(_LazyImage.LazyImage, _extends({
    preload: !lazyLoad,
    imageComponent: _Image.BaseImage
  }, props));
};

exports.Image = Image;
Image.displayName = "Image";

/** ResponsiveImage */
var ResponsiveImage = function ResponsiveImage(_ref2) {
  var _ref2$lazyLoad = _ref2.lazyLoad,
      lazyLoad = _ref2$lazyLoad === void 0 ? false : _ref2$lazyLoad,
      props = _objectWithoutProperties(_ref2, ["lazyLoad"]);

  return _react.default.createElement(_LazyImage.LazyImage, _extends({
    preload: !lazyLoad,
    imageComponent: _Image.BaseResponsiveImage
  }, props));
};

exports.ResponsiveImage = ResponsiveImage;
ResponsiveImage.displayName = "ResponsiveImage";
//# sourceMappingURL=Image.js.map